
const SESSION_KEY = "dashboardSession";

export interface DashboardSession {
  searchString: string;
  filterStatus: string;
  searchOption: string;
  filterOption: {
    page: number;
    limit: number;
    orderBy: string;
    orderIn: string;
    search: string;
    filterStatus: string;
    accountName: string;
    b2bAccounts: boolean;
    salesPersonId: string;
  };
  selectedLead: string | null;
  activeTab: string;
  selectedOrderBy: string | null;
  selectedOrderIn: string | null;
}

export const saveSession = (data: Partial<DashboardSession>) => {
  try {
    const existing = loadSession() || {};
    sessionStorage.setItem(SESSION_KEY, JSON.stringify({ ...existing, ...data }));
  } catch (_) {}
};

export const loadSession = (): DashboardSession | null => {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
};

export const clearSession = () => {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch (_) {}
};